import { DateTime } from 'luxon'

export const reminderOverdue = (reminder) => {
  const today = DateTime.now()
  const date = DateTime.fromISO(reminder.attributes['due-on'])

  return date < today
}